import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// form
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Stack, Switch, Typography, FormControlLabel, Button, Divider, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
// utils
import { fData } from '../../../utils/formatNumber';
// routes
import { PATH_SETDEALER } from '../../../routes/paths';
// assets
import { countries } from '../../../assets/data';
// components
import Label from '../../../components/label';
import { useSnackbar } from '../../../components/snackbar';
import { useSettingsContext } from '../../../components/settings';
import FormProvider, {
    RHFSelect,
    RHFSwitch,
    RHFTextField,
} from '../../../components/hook-form';




// ----------------------------------------------------------------------

//  UserNewEditForm.propTypes = {
//    isEdit: PropTypes.bool,
//    currentUser: PropTypes.object,
//  };

export default function DetailsAndAcknowledgement() {
    const navigate = useNavigate();

    // DataGrid
    const [pageSize, setPageSize] = useState(5);
    const { masterName } = useParams();
    const { themeStretch } = useSettingsContext();
    const [importHistoryColumns, setImportHistoryColumns] = useState([]);
    const [columnData, setColumnData] = useState([]);
    const [importHistoryRows, setImportHistoryRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [importHistoryLoading, setImportHistoryLoading] = useState(false);
    const [noOfRecords, setNoOfRecords] = useState(100);
    const [masterTitle, setMasterTitle] = useState('');



    const rows = [
        { srno: 1, equipmentID: 2, itemcode: 'Jon', itemname: 'hi', requestedquantity: 3, assignedquantity: 100, comment: 'ok' },
        { srno: 2, equipmentID: 3, itemcode: 'sdsdsd', itemname: 'fffff', requestedquantity: 3, assignedquantity: 50, comment: 'Ok' },
    ];

    const columns = [
        { field: 'srno', headerName: 'Sr No.', width: 230, description: 'Sr No.' },
        { field: 'equipmentID', headerName: 'Equipment ID', width: 150, description: 'Equipment ID' },
        { field: 'itemcode', headerName: 'Item Code', width: 200, description: 'Item Code' },
        { field: 'itemname', headerName: 'Item Name', width: 150, description: 'Item Name' },
        { field: 'requestedquantity', headerName: 'Requested Quantity', width: 130, description: 'Requested Quantity' },
        {
            field: 'assignedquantity',
            headerName: 'Assigned Quantity',
            width: 150,
            description: 'Assigned Quantity',
            renderCell: (cellValues) => (
                <TextField
                    sx={{ m: 1 }}
                    fullWidth
                    size="small"
                    id={`assignedquantity-${cellValues.row.id}`}
                    label="Assigned Quantity"
                    variant="outlined"
                    value={cellValues.row.assignedquantity}
                />
            ),
        },
        {
            field: 'comment',
            headerName: 'Comment',
            width: 200,
            description: 'Comment',
            renderCell: (cellValues) => (
                <TextField
                    sx={{ m: 1 }}
                    fullWidth
                    size="small"
                    id={`comment-${cellValues.row.id}`}
                    label="Comment"
                    variant="outlined"
                    value={cellValues.row.comment}
                />
            ),
        },
    ];





    const pendingcolumns =
        [
            {
                field: 'srno', headerName: 'Sr No.', width: 100, description: 'Sr No.'
            },
            { field: 'itemcode', headerName: 'Item Code', width: 120, description: 'Item Code' },
            { field: 'itemname', headerName: 'Item Name', width: 150, description: 'Item Name' },
            { field: 'requestedquantity', headerName: 'Requested Quantity', width: 130, description: 'Requested Quantity' },
            { field: 'dispatchedquantity', headerName: 'Dispatched Quantity', width: 150, description: 'Dispatched Quantity' },
            { field: 'pendingquantity', headerName: 'Pending Quantity', width: 200, description: 'Pending Quantity' },
        ]

    const { enqueueSnackbar } = useSnackbar();

    const NewUserSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        /*        email: Yup.string().required('Email is required').email('Email must be a valid email address'),   */
        phoneNumber: Yup.string().required('Phone number is required'),
        address: Yup.string().required('Address is required'),
        country: Yup.string().required('Country is required'),
        company: Yup.string().required('Company is required'),
        state: Yup.string().required('State is required'),
        city: Yup.string().required('City is required'),
        role: Yup.string().required('Role is required'),
    });



    const defaultValues = useMemo(
        () => ({
            name: '',
            email: '',
            phoneNumber: '',
            address: '',
            country: '',
            state: '',
            city: '',
            zipCode: '',
            isVerified: true,
            status: '',
            company: '',
            role: '',
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues,
    });

    const {
        reset,
        watch,
        control,
        setValue,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const values = watch();

    useEffect(() => {

        reset(defaultValues);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async (data) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 500));
            reset();
            enqueueSnackbar('Create success!');
            console.log('DATA', data);
            navigate(PATH_SETDEALER.dealer.maindealerpage);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDrop = useCallback(
        (acceptedFiles) => {
            const file = acceptedFiles[0];

            const newFile = Object.assign(file, {
                preview: URL.createObjectURL(file),
            });

            if (file) {
                setValue('avatarUrl', newFile, { shouldValidate: true });
            }
        },
        [setValue]
    );

    return (
        <Card sx={{ height: "auto", width: '100%', mt: 2 }}>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

                <Grid container spacing={1} sx={{ p: 4 }}>
                    <Card sx={{ height: "auto", width: '100%', mt: 2, p: 3 }}>
                        <Grid item xs={12} md={12}>
                            <Box
                                rowGap={3}
                                columnGap={2}
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(1, 1fr)',
                                    sm: 'repeat(3, 1fr)',
                                }}
                            >
                                <Typography variant="body1" gutterBottom>
                                    Request ID :
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    Request Type :
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    Request Type :
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    DC No:
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    DC Date :
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    AWB# :
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    AWB Date :
                                </Typography>




                            </Box>


                        </Grid>
                       
                    </Card>
                    <Stack direction="column" spacing={1} mt={3}>
                        <Divider sx={{ width: '100%' }} /> {/* Set width to '100%' */}
                        <Typography variant="h5" sx={{ mt: 5 ,width:'850px'}} >
                            DC Items 
                        </Typography>
                    </Stack>
                    <Card sx={{ height: "auto", width: '100%', mt: 1 }}>
                        <Grid item xs={12} md={12} >

                            <DataGrid
                                rows={rows}
                                columns={columns}
                                getRowId={(row) => rows.indexOf(row)}
                                disableSelectionOnClick
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[100, 200, 300]}
                                sx={{
                                    '.MuiDataGrid-row': {
                                        pl: 0
                                    },
                                    '.MuiDataGrid-columnHeader': {
                                        pl: 1
                                    },
                                    '.MuiDataGrid-columnHeaderCheckbox': {
                                        pl: 0
                                    }
                                }}

                                //  rowHeight={30}
                                //  headerHeight={35}
                                density='compact'
                                rowHeight='auto'
                            />

                        </Grid>
                    </Card>
                    <Stack direction="column" spacing={1} mt={3}>
                        <Divider sx={{ width: '100%' }} /> {/* Set width to '100%' */}
                        <Typography variant="h5" sx={{ mt: 5, width: '850px' }} >
                            Pending Items
                        </Typography>
                    </Stack>
                    <Card sx={{ height: "auto", width: '100%', mt: 1 }}>
                        <Grid item xs={12} md={12} >

                            <DataGrid
                                rows={rowData}
                                columns={pendingcolumns}
                                getRowId={(row) => rowData.indexOf(row)}
                                disableSelectionOnClick
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[100, 200, 300]}
                                sx={{
                                    '.MuiDataGrid-row': {
                                        pl: 0
                                    },
                                    '.MuiDataGrid-columnHeader': {
                                        pl: 1
                                    },
                                    '.MuiDataGrid-columnHeaderCheckbox': {
                                        pl: 0
                                    }
                                }}

                                //  rowHeight={30}
                                //  headerHeight={35}
                                density='compact'
                            />

                        </Grid>
                    </Card>
                    <Stack direction="row" justifyContent="flex-end" alignItems="flex-end" spacing={1} sx={{ mt: 3 }}>
                        <Button variant="contained" >Cancel</Button>
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                            Acknowledge
                        </LoadingButton>
                    </Stack>
                </Grid>

            </FormProvider>
        </Card>

    );
}
